import React from "react";
import TaskCard from "./TaskCard";
import { FaPlus } from "react-icons/fa";

const COLUMNS = [
  { key: "To Do", label: "To Do", colorClass: "todo" },
  { key: "In Progress", label: "In Progress", colorClass: "inprogress" },
  { key: "In Review", label: "In Review", colorClass: "inreview" },
  { key: "Completed", label: "Completed", colorClass: "completed" },
];

const TaskBoardView = ({
  tasks,
  onEdit,
  onDuplicate,
  onDelete,
  onStatusChange,
  onCreateWithStatus,
}) => {
  const getTasksByStatus = (statusKey) => {
    return tasks.filter((t) => (t.status || "To Do") === statusKey);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, targetStatus) => {
    e.preventDefault();
    const taskIdStr = e.dataTransfer.getData("text/plain");
    if (taskIdStr) {
      const taskId = parseInt(taskIdStr, 10);
      onStatusChange(taskId, targetStatus);
    }
  };

  const handleDragStart = (e, taskId) => {
    e.dataTransfer.setData("text/plain", taskId.toString());
  };

  return (
    <div className="tm-board-container">
      {COLUMNS.map((col) => {
        const colTasks = getTasksByStatus(col.key);
        return (
          <div
            key={col.key}
            className="tm-board-col"
            onDragOver={handleDragOver}
            onDrop={(e) => handleDrop(e, col.key)}
          >
            {/* Column Header */}
            <div className="tm-board-col-header">
              <div className="tm-col-title-badge">
                <span className={`tm-col-dot ${col.colorClass}`} />
                <span>{col.label}</span>
                <span className="tm-col-count">{colTasks.length}</span>
              </div>

              {onCreateWithStatus && (
                <button
                  className="tm-card-menu-btn"
                  title={`Add task to ${col.label}`}
                  onClick={() => onCreateWithStatus(col.key)}
                >
                  <FaPlus />
                </button>
              )}
            </div>

            {/* Task Cards in this column */}
            <div className="tm-board-col-body">
              {colTasks.length === 0 ? (
                <div
                  style={{
                    padding: "30px 10px",
                    textAlign: "center",
                    color: "#94a3b8",
                    fontSize: "13px",
                    border: "2px dashed #e2e8f0",
                    borderRadius: "8px",
                    marginTop: "6px",
                  }}
                >
                  No tasks here
                </div>
              ) : (
                colTasks.map((task) => (
                  <div
                    key={task.id}
                    draggable
                    onDragStart={(e) => handleDragStart(e, task.id)}
                    style={{ cursor: "grab" }}
                  >
                    <TaskCard
                      task={task}
                      onEdit={onEdit}
                      onDuplicate={onDuplicate}
                      onDelete={onDelete}
                      onStatusChange={onStatusChange}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TaskBoardView;
